import {Box, styled} from '@mui/material';

export const ProductCardLEOContainer = styled(Box)(({theme}) => ({
  position: 'relative',
  borderRadius: theme.spacing(0.5),
  overflow: 'hidden',
  '&.PDPRevamp': {
    border: `${theme.spacing(0.125)} solid ${theme.palette.grey[100]}`,
    borderRadius: theme.spacing(1)
  },
  '&.PDPRevamp.compact': {
    border: 'none',
    borderRadius: 0
  }
}));

export const LeoImageSkeletonWrapper = styled(Box)(() => ({
  '&': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    visibility: 'visible !important',
    width: '100%',
    height: '100%'
  }
}));
